/* eslint-disable import/no-unresolved */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import dompurify from 'dompurify';
import {
  Row,
  Col,
  Button,
  Input,
  Select,
  List,
  // Radio,
  DatePicker,
  message,
  Collapse,
  Steps,
  Tooltip
} from 'antd';
import moment from 'moment';
const { Option } = Select;
const { Step } = Steps;
// const { Search } = Input;
const { Panel } = Collapse;
const InputGroup = Input.Group;

import {
  ssrHandler,
  sortingChange,
  fetchActiveReportsMetaData,
  fetchShipmentLog,
  resetShipmentLog,
  fetchAsyncLogMetaData,
  postAsyncLog,
  fetchAsyncLog,
  fetchServiceMetaData,
  fetchScans,
  courierAccountsFetch
} from '../actions/sessionActions';

import Notification from '../sharedComponent/Notification';
import JsonView from '../sharedComponent/JsonView';

const steps = [
  {
    title: 'Shipment Detail',
    content: 'First-content'
  },
  {
    title: 'Search',
    content: 'Second-content'
  }
];

const columns = [
  {
    title: 'Status',
    key: 'courier_partner__name',
    width: 20
  },
  {
    title: 'Remark',
    key: 'account_type__account_name',
    width: 35
  },
  {
    title: 'Latest Timestamp',
    key: 'enterprise_user__name',
    width: 20
  },
  {
    title: 'Created At',
    key: 'enterprise_user__name',
    width: 15
  },
  {
    title: 'Action',
    key: 'file_upload',
    width: 10
  }
];

export class ShipmentLog extends Component {
  static async fetchData({ dispatch }, match, route) {
    await dispatch(ssrHandler(route.path));
    // await dispatch(fetchCp());
  }
  constructor() {
    super();
    this.state = {
      searchInput: '',
      enterpriseId: undefined,
      search: '',
      searchBy: 'reference_number',
      eventType: null,
      serviceType: null,
      jobId: null,
      response: null,
      url: null,
      count: 0,
      date: undefined,
      isJobCompleted: false,
      isFetching: false,
      current: 0,
      webhook: {
        scan: {
          awb: null,
          enterpriseId: null,
          isFetching: false,
          list: [],
          eventType: null,
          timestamp: ''
        },
        final: { timestamp: '', isFetching: false }
      },
      startDate: '',
      endDate: '',
      cp: { list: [], cpRawData: null, selectedCp: null },
      accounts: { list: [], selected: [], selectedAccount: null }
    };
  }

  componentDidMount() {
    this.props.fetchActiveReportsMetaData('enterprise');
    this.props.fetchServiceMetaData();
  }

  reset = () => {
    this.dateChange(null);
    this.setState({
      searchInput: '',
      searchBy: 'reference_number',
      enterpriseId: null,
      count: 0,
      isJobCompleted: true,
      eventType: null,
      serviceType: null,
      date: undefined,
      isFetching: false,
      response: null,
      url: null
    });
    this.props.resetShipmentLog();
  };

  onChange = e => {
    if (e.target.name === 'scan') {
      const { webhook } = this.state;
      webhook.scan.awb = e.target.value;
      this.setState({ webhook });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  handleChange = (value, key, parentKey) => {
    if (parentKey === 'scan') {
      const { webhook } = this.state;
      webhook.scan[key] = value;
      this.setState({ webhook });
      if (key === 'enterpriseId') {
        this.props.fetchAsyncLogMetaData(value);
      }
    } else {
      this.setState({ [key]: value });
      if (key === 'enterpriseId') {
        this.setState({
          eventType: null,
          cp: { ...this.state.cp, selectedCp: null },
          accounts: { ...this.state.accounts, selectedAccount: null },
          startDate: null,
          endDate: null
        });
        const enterpriseId = {
          id: value
        };

        courierAccountsFetch(enterpriseId).then(res => {
          if (res.meta.status === 200) {
            const data = res.result;
            const cpListData = [];
            const cpName = [];
            data.map(cp => {
              if (cpName.includes(cp.courier_partenr_name) !== true) {
                cpName.push(cp.courier_partenr_name);
                cpListData.push({
                  id: cp.account_id,
                  name: cp.courier_partenr_name
                });
              }
            });
            this.setState({
              cp: {
                ...this.state.cp,
                list: cpListData,
                cpRawData: data
              },
              enterprise: {
                ...this.state.enterprise,
                selected: value
              }
            });
          }
        });
        this.props.fetchAsyncLogMetaData(value);
      }
      if (key === 'cp') {
        const filteredAccountsId = this.state.cp.cpRawData.filter(item => {
          return item.account_id === value;
        });
        const filteredAccountsName = this.state.cp.cpRawData.filter(item => {
          return item.partner_id === filteredAccountsId[0].partner_id;
        });

        this.setState({
          cp: {
            ...this.state.cp,
            selectedCp: value
          },
          accounts: {
            ...this.state.accounts,
            selected: filteredAccountsName,
            selectedAccount: null
          }
        });
      }
      if (key === 'account') {
        this.setState({
          accounts: {
            ...this.state.accounts,
            selectedAccount: value
          }
        });
      }
      if (key === 'serviceType') {
        this.setState({
          searchBy: value === 2 || value === 26 ? 'awb' : 'reference_number',
          startDate: null,
          endDate: null
        });
        // Setting searchBy to awb if serviceType is 2 or 26 as default and reference_number for others
      }
      if (key === 'searchBy') {
        this.setState({ searchBy: value });
      }
    }
  };

  recursiveFetchAsyncLog = jobId => {
    setTimeout(() => {
      let { isJobCompleted, count } = this.state;
      count += 1;
      if (isJobCompleted) {
        return;
      } else {
        this.props.fetchAsyncLog(jobId).then(res => {
          if (res.meta.status === 200) {
            if (
              res.result.url ||
              res.result.response ||
              res.meta.status === 200
            ) {
              const { response, url } = res.result;
              const { webhook } = this.state;
              webhook.final.isFetching = false;
              isJobCompleted = true;
              this.setState({
                response,
                url,
                isJobCompleted,
                isFetching: false,
                search: 'webhook',
                count: 0,
                webhook
              });
              if (response === '' && url === '') {
                return message.info('No data found');
              }
            } else if (count < 61) {
              this.recursiveFetchAsyncLog(jobId);
            } else {
              alert('we were unable to get information for your query');
              isJobCompleted = true;
              this.webhookReset();
            }
          } else if (res.meta.status === 102 && count < 61) {
            this.recursiveFetchAsyncLog(jobId);
          } else {
            alert('we were unable to get information for your query');
            isJobCompleted = true;
            this.webhookReset();
          }
          this.setState({ isJobCompleted, count });
        });
      }
    }, 5000);
  };

  handleSearch = () => {
    const {
      enterpriseId,
      searchInput,
      serviceType,
      searchBy,
      accounts,
      startDate,
      endDate
    } = this.state;
    if (!searchInput && serviceType !== 89) {
      return message.error('Please enter text in search input');
    }
    if (!enterpriseId) {
      return message.error('Please select enterprise');
    }

    if (serviceType === 89) {
      if (!accounts.selectedAccount || !startDate || !endDate) {
        return message.error(
          'Carrier Account, startDate, endDate must not be empty when service is Auto Fetch Preassigned AWB'
        );
      }

      const start = new Date(startDate);
      const end = new Date(endDate);

      if (start > end) {
        return message.error('Start date cannot be greater than end date.');
      }
    }

    const postdata = {
      enterprise: enterpriseId,
      searchInput: encodeURIComponent(searchInput.trim()),
      serviceType: serviceType,
      startDate: startDate,
      endDate: endDate,
      cpAccountId: accounts.selectedAccount,
      searchBy
    };

    this.setState({ isFetching: true, search: 'api' });
    this.props.resetShipmentLog();
    this.props.fetchShipmentLog(postdata).then(res => {
      if (res) {
        this.setState({ isFetching: false });
      }
    });
  };

  handleSearchScan = () => {
    const { webhook } = this.state;
    if (!webhook.scan.enterpriseId) {
      return message.error('Please select enterprise');
    }
    if (!webhook.scan.awb) {
      return message.error('Please enter awb');
    }
    webhook.scan.isFetching = true;
    this.setState({ webhook });
    this.props
      .fetchScans(webhook.scan.enterpriseId, webhook.scan.awb)
      .then(res => {
        if (res) {
          webhook.scan.isFetching = false;
          if (res.meta.status === 200) {
            webhook.scan.list = res.results.scans;
          } else {
            webhook.scan.list = [];
            message.info(res.meta.message);
          }
          this.setState({ webhook });
        }
      });
  };

  webhookReset = () => {
    this.dateChange(null);
    this.props.resetShipmentLog();
    this.setState({
      count: 0,
      isJobCompleted: false,
      current: 0,
      webhook: {
        scan: {
          awb: null,
          enterpriseId: null,
          isFetching: false,
          list: [],
          eventType: null,
          timestamp: ''
        },
        final: { isFetching: false }
      },
      search: 'api'
    });
  };

  next = (step, index) => {
    let { current, webhook } = this.state;
    current = step;
    if (step === 2) {
      if (!webhook.scan.enterpriseId) {
        return message.error('Please select enterprise');
      }
      if (!webhook.scan.eventType) {
        return message.error('Please select event type');
      }
      if (
        !webhook.scan.date &&
        (webhook.scan.eventType === 'retrigger_webhook_notification_consumer' ||
          webhook.scan.eventType === 'failed_webhook_notification_consumer')
      ) {
        return message.error('Please select date');
      }
      const query = {
        job_type: 1,
        payload: {
          log_file_name: webhook.scan.eventType,
          // date: date.date(),
          pattern_to_search: webhook.scan.awb,
          total_lines: 15
        }
      };
      let datetime = null;
      if (
        webhook.scan.eventType === 'retrigger_webhook_notification_consumer' ||
        webhook.scan.eventType === 'failed_webhook_notification_consumer'
      ) {
        datetime = webhook.scan.date;
      } else {
        datetime = webhook.scan.timestamp;
      }
      if (datetime) {
        query.payload.date = moment(datetime).date();
        query.payload.month = moment(datetime).month() + 1;
        query.payload.year = moment(datetime).year();
        query.payload.time = moment(datetime).format('HH:mm:ss');
      }
      webhook.final.isFetching = true;
      this.setState({ webhook });
      this.props.postAsyncLog(query).then(res => {
        if (res.meta.status === 202) {
          const jobId = res.result.job_id;
          webhook.final.isFetching = true;
          this.setState({ webhook });
          this.setState({ jobId, isJobCompleted: false });
          this.recursiveFetchAsyncLog(jobId);
        }
      });
    } else {
      webhook.scan.timestamp = webhook.scan.list[index].latest_timestamp;
      this.props.resetShipmentLog();
      this.setState({ current, webhook });
    }
  };

  previous = () => {
    let { current, webhook } = this.state;
    current -= 1;
    webhook.scan.timestamp = '';
    webhook.final.isFetching = false;
    const count = 0;
    const isJobCompleted = true;
    this.setState({
      current,
      webhook,
      count,
      isJobCompleted,
      url: null,
      response: null
    });
    this.props.resetShipmentLog();
  };

  renderFetchingText = () => {
    const { count } = this.state;
    if (count < 5) {
      return 'Fetching';
    } else {
      return 'This may take a while';
    }
  };

  dateChange = (date, dateString, name) => {
    const { webhook } = this.state;
    if (name === 'webhookDate') {
      webhook.scan.date = date;
      this.setState({ webhook });
    } else {
      this.setState({ [name]: dateString });
    }
  };

  render() {
    const { metadata, shipmentLog } = this.props;
    const {
      count,
      isJobCompleted,
      // date,
      isFetching,
      search,
      url,
      response,
      current,
      webhook
    } = this.state;
    const sanitizer = dompurify.sanitize;
    return (
      <div>
        <Collapse
          accordion
          defaultActiveKey={['1']}
          expandIconPosition={'right'}
        >
          <Panel header="Clickpost API" key="1">
            <Row className="margin-bottom-10">
              <Col span={4}>
                <div
                  className="global-search-wrapper"
                  style={{ width: '100%' }}
                >
                  <Select
                    showSearch
                    style={{ width: '96%' }}
                    placeholder="Select enterprise"
                    optionFilterProp="children"
                    value={
                      this.state.enterpriseId
                        ? this.state.enterpriseId
                        : undefined
                    }
                    onChange={value => this.handleChange(value, 'enterpriseId')}
                    allowClear={true}
                    filterOption={(input, option) =>
                      option.props?.children
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    }
                  >
                    {metadata.enterprise.list.map((enterprise, i) => (
                      <Option key={i} value={enterprise.id}>
                        {enterprise.name}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col>
              <Col span={6}>
                <div
                  className="global-search-wrapper"
                  style={{ width: '100%' }}
                >
                  <Select
                    showSearch
                    style={{ width: '96%' }}
                    placeholder="Select service type"
                    optionFilterProp="children"
                    value={
                      this.state.serviceType
                        ? this.state.serviceType
                        : undefined
                    }
                    onChange={value => this.handleChange(value, 'serviceType')}
                    allowClear={true}
                    filterOption={(input, option) =>
                      option.props?.children
                        ?.toLowerCase()
                        ?.indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {metadata.service.list.map((item, i) => (
                      <Option key={i} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col>
              {this.state.serviceType === 89 ? (
                <>
                  <Col span={8}>
                    <div
                      className="global-search-wrapper"
                      style={{ width: '100%' }}
                    >
                      <Select
                        showSearch
                        style={{ width: '96%' }}
                        placeholder="Select Courier Partner"
                        optionFilterProp="children"
                        value={
                          this.state.cp.selectedCp
                            ? this.state.cp.selectedCp
                            : undefined
                        }
                        onChange={value => this.handleChange(value, 'cp')}
                        filterOption={(input, option) =>
                          option.props?.children
                            ?.toLowerCase()
                            ?.includes(input?.toLowerCase())
                        }
                      >
                        {this.state.cp.list.map((item, i) => (
                          <Option key={i} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </Col>
                </>
              ) : (
                <Col span={8}>
                  {this.state.serviceType !== 2 ? (
                    <Input
                      name="searchInput"
                      placeholder={`Enter ${
                        this.state.searchBy === 'awb'
                          ? 'AWB'
                          : 'Reference Number'
                      } here`}
                      className="ant-input"
                      value={this.state.searchInput}
                      onChange={this.onChange}
                    />
                  ) : (
                    <InputGroup compact>
                      <Select
                        defaultValue="awb"
                        style={{ width: '50%' }}
                        onChange={value => this.handleChange(value, 'searchBy')}
                      >
                        <Option value="awb">AWB</Option>
                        <Option value="reference_number">
                          Reference Number
                        </Option>
                      </Select>
                      <Input
                        name="searchInput"
                        placeholder={`Enter ${
                          this.state.searchBy === 'awb'
                            ? 'AWB'
                            : 'Reference Number'
                        } here`}
                        className="ant-input"
                        style={{ width: '50%' }}
                        value={this.state.searchInput}
                        onChange={this.onChange}
                      />
                    </InputGroup>
                  )}
                </Col>
              )}
              <Col span={6} className="text-right">
                <Button
                  type="primary"
                  className="margin-right-10"
                  onClick={this.handleSearch}
                  disabled={isFetching}
                  loading={isFetching}
                >
                  {isFetching ? 'Processing...' : 'Search'}
                </Button>
                <Button type="primary" onClick={this.reset}>
                  Reset
                </Button>
              </Col>
            </Row>
            <Row className="d-flex margin-bottom-10">
              {this.state.enterpriseId && this.state.serviceType == 89 && (
                <>
                  <Col span={6}>
                    <div
                      className="global-search-wrapper"
                      style={{ width: '100%' }}
                    >
                      <DatePicker
                        defaultValue={
                          this.state.startDate
                            ? moment(this.state.startDate)
                            : null
                        }
                        style={{ width: '96%' }}
                        placeholder="Select Start Date"
                        name="startDate"
                        onChange={(value, defaultPickerValue) =>
                          this.dateChange(
                            value,
                            defaultPickerValue,
                            'startDate'
                          )
                        }
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div
                      className="global-search-wrapper"
                      style={{ width: '100%' }}
                    >
                      <DatePicker
                        defaultValue={
                          this.state.endDate ? moment(this.state.endDate) : null
                        }
                        style={{ width: '96%' }}
                        placeholder="Select End Date"
                        name="endDate"
                        onChange={(value, defaultPickerValue) =>
                          this.dateChange(value, defaultPickerValue, 'endDate')
                        }
                      />
                    </div>
                  </Col>
                  {this.state.cp.selectedCp && (
                    <Col span={6}>
                      <div
                        className="global-search-wrapper"
                        style={{ width: '100%' }}
                      >
                        <Select
                          showSearch
                          style={{ width: '96%' }}
                          placeholder="Select Account"
                          optionFilterProp="children"
                          value={
                            this.state.accounts.selectedAccount
                              ? this.state.accounts.selectedAccount
                              : undefined
                          }
                          onChange={value =>
                            this.handleChange(value, 'account')
                          }
                          filterOption={(input, option) => {
                            return option.props?.children?.props?.children
                              ?.toLowerCase()
                              ?.includes(input.toLowerCase());
                          }}
                        >
                          {this.state.accounts.selected.map((item, i) => (
                            <Option key={i} value={item.account_id}>
                              <Tooltip
                                title={`${item.courier_partenr_name} - ${item.account_code} `}
                              >
                                {`${item.courier_partenr_name} - ${item.account_code} `}
                              </Tooltip>
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                  )}
                </>
              )}
            </Row>
            <Row>
              {count && !isJobCompleted ? (
                <Col span={24} className="text-center">
                  <div className="dot-flashing" />
                  <p className="fetching-message text-center">
                    {this.renderFetchingText()}
                  </p>
                </Col>
              ) : url ? (
                <p>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    Click here to download log file
                  </a>
                </p>
              ) : response ? (
                <p dangerouslySetInnerHTML={{ __html: sanitizer(response) }} />
              ) : null}
              <Col span={24} className="margin-bottom-10">
                {shipmentLog.isFetching ? null : (
                  <Fragment>
                    {shipmentLog.list.length <= 0 ? (
                      search === 'api' ? (
                        <div>&nbsp; No Data</div>
                      ) : null
                    ) : (
                      <List
                        bordered
                        dataSource={shipmentLog.list}
                        renderItem={item => (
                          <List.Item style={{ display: 'block' }}>
                            <p />
                            <p>
                              <b>
                                Created At:{' '}
                                {moment(item.created_at).format(
                                  'DD-MMM-YYYY hh:mm:ss A'
                                )}
                              </b>
                            </p>
                            <p>
                              <b>ClickPost Request:</b>
                            </p>
                            <JsonView data={item.clickpost_request} />
                            <br />
                            <p>
                              <b>Courier Partner Request:</b>
                            </p>
                            <JsonView data={item.courier_partner_request} />
                            <br />
                            <p>
                              <b>ClickPost Response:</b>
                            </p>
                            <JsonView data={item.clickpost_response} />
                            <br />
                            <p>
                              <b>Courier Partner Response:</b>
                            </p>
                            <JsonView data={item.courier_partner_response} />
                          </List.Item>
                        )}
                      />
                    )}
                  </Fragment>
                )}
              </Col>
            </Row>
          </Panel>
          <Panel header="Webhook" key="2">
            <Steps current={current} size="small">
              {steps.map(item => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
            <div className="steps-content">
              {current === 0 ? (
                <Row>
                  <Col span={4} className="padding-right-10">
                    <div
                      className="global-search-wrapper"
                      style={{ width: '100%' }}
                    >
                      <Select
                        showSearch
                        style={{ width: '100%' }}
                        placeholder="Select enterprise"
                        optionFilterProp="children"
                        value={
                          this.state.webhook.scan.enterpriseId
                            ? this.state.webhook.scan.enterpriseId
                            : undefined
                        }
                        onChange={value =>
                          this.handleChange(value, 'enterpriseId', 'scan')
                        }
                        allowClear={true}
                        filterOption={(input, option) =>
                          option.props.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                      >
                        {metadata.enterprise.list.map((enterprise, i) => (
                          <Option key={i} value={enterprise.id}>
                            {enterprise.name}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </Col>
                  <Col span={16}>
                    <Input
                      name="scan"
                      placeholder={`Enter AWB here`}
                      className="ant-input"
                      value={this.state.webhook.scan.awb}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col span={4} className="text-right">
                    <Button
                      type="primary"
                      className="margin-right-10"
                      onClick={this.handleSearchScan}
                      disabled={isFetching}
                      loading={isFetching}
                    >
                      {isFetching ? 'Processing...' : 'Search'}
                    </Button>
                    <Button type="primary" onClick={this.webhookReset}>
                      Reset
                    </Button>
                  </Col>
                  {webhook.scan.list.length > 0 && !webhook.scan.isFetching ? (
                    <Col span={24}>
                      <table
                        className={`ant-table ant-table-small width-100pt margin-top-10 text-left`}
                      >
                        <thead className="ant-table-thead">
                          <tr>
                            {columns.map((item, i) => (
                              <th
                                className="padding-8"
                                key={i}
                                width={`${item.width}%`}
                              >
                                {item.title}
                                {/* <Icon type="sort-ascending" /> */}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody className="ant-table-tbody">
                          {webhook.scan.list.map((item, i) => (
                            <tr key={i}>
                              <td className="padding-8">{item.uber_status}</td>
                              <td className="padding-8">{item.remark}</td>
                              <td className="padding-8">
                                {item.latest_timestamp}
                              </td>
                              <td className="padding-8">{item.created_at}</td>
                              <td className="padding-8">
                                <Button
                                  type="primary"
                                  onClick={e => this.next(1, i, e)}
                                >
                                  Next
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </Col>
                  ) : null}
                </Row>
              ) : null}
              {current === 1 ? (
                <Row>
                  <Col span={6}>
                    <div
                      className="global-search-wrapper"
                      style={{ width: '100%' }}
                    >
                      <Select
                        showSearch
                        style={{ width: '100%' }}
                        placeholder="Select event type"
                        optionFilterProp="children"
                        value={
                          webhook.scan.eventType
                            ? webhook.scan.eventType
                            : undefined
                        }
                        onChange={value =>
                          this.handleChange(value, 'eventType', 'scan')
                        }
                        allowClear={true}
                        filterOption={(input, option) =>
                          option.props?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                      >
                        {shipmentLog.async.metadata.map((item, i) => (
                          <Option key={i} value={item.value}>
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </Col>
                  {webhook.scan.eventType ===
                    'retrigger_webhook_notification_consumer' ||
                  webhook.scan.eventType ===
                    'failed_webhook_notification_consumer' ? (
                    <Col span={3}>
                      <div
                        className="global-search-wrapper"
                        style={{ width: '100%' }}
                      >
                        <DatePicker
                          onChange={value =>
                            this.dateChange(value, 'webhookDate')
                          }
                          allowClear={false}
                          value={
                            webhook.scan.date !== undefined
                              ? moment(webhook.scan.date)
                              : undefined
                          }
                        />
                      </div>
                    </Col>
                  ) : null}
                </Row>
              ) : null}
            </div>
            <div className="steps-action">
              {current === steps.length - 1 && (
                <Button
                  type="primary"
                  className="margin-left-10"
                  onClick={e => this.next(2, e)}
                  disabled={webhook.final.isFetching}
                  loading={webhook.final.isFetching}
                >
                  {webhook.final.isFetching ? 'Processing...' : 'Search'}
                </Button>
              )}
              {current > 0 && (
                <Button
                  style={{ margin: '0 8px' }}
                  onClick={() => this.previous()}
                >
                  Previous
                </Button>
              )}
            </div>
            {current === 1 ? (
              <Row>
                {count && !isJobCompleted ? (
                  <Col span={24} className="margin-bottom-10 text-center">
                    <div className="dot-flashing" />
                    <p className="fetching-message text-center">
                      {this.renderFetchingText()}
                    </p>
                  </Col>
                ) : url ? (
                  <p>
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      Click here to download log file
                    </a>
                  </p>
                ) : response ? (
                  <p
                    className="margin-top-10"
                    dangerouslySetInnerHTML={{ __html: sanitizer(response) }}
                  />
                ) : null}
                <Col span={24} className="margin-bottom-10">
                  {shipmentLog.isFetching ? null : (
                    <Fragment>
                      {shipmentLog.list.length <= 0 ? (
                        search === 'webhook' ? (
                          <div>&nbsp; No Data</div>
                        ) : null
                      ) : (
                        <List
                          bordered
                          dataSource={shipmentLog.list}
                          renderItem={item => (
                            <List.Item style={{ display: 'block' }}>
                              <p>
                                <b>ClickPost Request:</b>
                              </p>
                              <JsonView data={item.clickpost_request} />
                              <br />
                              <p>
                                <b>Courier Partner Request:</b>
                              </p>
                              <JsonView data={item.courier_partner_request} />
                              <br />
                              <p>
                                <b>ClickPost Response:</b>
                              </p>
                              <JsonView data={item.clickpost_response} />
                              <br />
                              <p>
                                <b>Courier Partner Response:</b>
                              </p>
                              <JsonView data={item.courier_partner_response} />
                            </List.Item>
                          )}
                        />
                      )}
                    </Fragment>
                  )}
                </Col>
              </Row>
            ) : null}
          </Panel>

          <Panel header="Notification" key="3">
            <Notification EnterpriseData={metadata} />
          </Panel>
        </Collapse>
      </div>
    );
  }
}

ShipmentLog.propTypes = {
  activeReports: PropTypes.object,
  config: PropTypes.object,
  metadata: PropTypes.object,
  shipmentLog: PropTypes.object,
  match: PropTypes.object,
  fetchActiveReportsMetaData: PropTypes.func,
  fetchShipmentLog: PropTypes.func,
  sortingChange: PropTypes.func,
  sortingJobs: PropTypes.func,
  resetShipmentLog: PropTypes.func,
  fetchAsyncLogMetaData: PropTypes.func,
  postAsyncLog: PropTypes.func,
  fetchAsyncLog: PropTypes.func,
  fetchServiceMetaData: PropTypes.func,
  fetchScans: PropTypes.func
};

ShipmentLog.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  jobs: state.session.jobs,
  metadata: state.session.metadata,
  shipmentLog: state.session.shipmentLog,
  activeReports: state.session.activeReports
});

const mapDispatchToProps = dispatch => ({
  sortingChange: data => dispatch(sortingChange(data)),
  fetchActiveReportsMetaData: data =>
    dispatch(fetchActiveReportsMetaData(data)),
  fetchShipmentLog: query => dispatch(fetchShipmentLog(query)),
  resetShipmentLog: () => dispatch(resetShipmentLog()),
  fetchAsyncLogMetaData: id => dispatch(fetchAsyncLogMetaData(id)),
  postAsyncLog: query => dispatch(postAsyncLog(query)),
  fetchAsyncLog: query => dispatch(fetchAsyncLog(query)),
  fetchServiceMetaData: () => dispatch(fetchServiceMetaData()),
  fetchScans: (enterpriseId, awb) => dispatch(fetchScans(enterpriseId, awb))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipmentLog)
);
